import { AfterViewInit, Component, Input, NgZone, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import * as am5 from '@amcharts/amcharts5';
import * as am5wc from '@amcharts/amcharts5/wc';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import * as am5exporting from '@amcharts/amcharts5/plugins/exporting';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-word-cloud-chart',
	standalone: true,
	imports: [CommonModule, MatButtonModule, MatIconModule],
	template: `
		<div [id]="chartId" style="width: 100%; height: 400px;"></div>
		<div class="d-flex justify-content-end align-items-center mb-4">
			<button mat-raised-button color="primary" (click)="exportAsImage()" aria-label="Export word cloud">
				<mat-icon class="m-0">download</mat-icon>
			</button>
		</div>
	`,
})
export class WordCloudChartComponent implements OnChanges, OnDestroy, AfterViewInit {
	chartId = `wordCloud-${Math.random().toString(36).substr(2, 9)}`;

	@Input() data: { word: string; count: number }[] = [];

	private root!: am5.Root;
	private exporting!: am5exporting.Exporting;

	private viewInitialized = false;

	constructor(private zone: NgZone) {}

	ngAfterViewInit(): void {
		this.viewInitialized = true;
		if (this.data?.length > 0) {
			this.renderChart();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.viewInitialized && changes['data'] && this.data?.length > 0) {
			this.renderChart();
		}
	}

	private renderChart(): void {
		this.disposeChart();

		this.zone.runOutsideAngular(() => {
			const root = am5.Root.new(this.chartId);
			this.root = root;

			root.setThemes([am5themes_Animated.new(root)]);

			const zoomableContainer = root.container.children.push(
				am5.ZoomableContainer.new(root, {
					width: am5.percent(100),
					height: am5.percent(100),
					wheelable: true,
					pinchZoom: true,
				})
			);

			zoomableContainer.children.push(am5.ZoomTools.new(root, { target: zoomableContainer }));

			let text = '';
			this.data.forEach(item => {
				text += `${item.word} `.repeat(item.count);
			});

			const wordCloud = zoomableContainer.contents.children.push(
				am5wc.WordCloud.new(root, {
					maxCount: 100,
					minWordLength: 1,
					minFontSize: am5.percent(5),
					maxFontSize: am5.percent(35),
					text,
				})
			);

			wordCloud.labels.template.setAll({
				paddingTop: 5,
				paddingBottom: 5,
				paddingLeft: 5,
				paddingRight: 5,
				fontFamily: 'Arial, sans-serif',
			});


			// wordCloud.data.setAll(
			// 	this.data.map(item => ({
			// 		word: item.word,
			// 		value: item.count,
			// 	}))
			// );

			// wordCloud.appear(1000, 100);

			this.exporting = am5exporting.Exporting.new(root, {
				pngOptions: {
					quality: 0.9,
					maintainPixelRatio: true,
				},
			});
		});
	}

	exportAsImage(): void {
		this.exporting?.download('png');
	}

	ngOnDestroy(): void {
		this.disposeChart();
	}

	private disposeChart(): void {
		if (this.root) {
			this.root.dispose();
		}
	}
}
